/*
 * File: ProcedureFormDoubleButtons.js
 * Project: mp-mobile-app
 *  *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles the two buttons on the Procedure Detail Page - Review & Finish, Add Another
 */
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";

const styles = theme => ({
  buttons: {
    width: "45%",
    margin: "2%",
    background: theme.palette.common.buttonGradient + " !important;",
    color: theme.palette.common.white,
    zIndex: 2
  }
});

const ProcedureFormDoubleButtons = ({
  classes,
  onReviewClick,
  onAddAnotherClick
}) => {
  return (
    <React.Fragment>
      <Button
        variant="contained"
        color="primary"
        className={classes.buttons}
        onClick={onAddAnotherClick}
      >
        Add Another
      </Button>
      <Button
        variant="contained"
        color="primary"
        className={classes.buttons}
        onClick={onReviewClick}
      >
        Review & Finish
      </Button>
    </React.Fragment>
  );
};

ProcedureFormDoubleButtons.propTypes = {
  classes: PropTypes.object.isRequired,
  onReviewClick: PropTypes.func.isRequired,
  onAddAnotherClick: PropTypes.func.isRequired
};

export default withStyles(styles)(ProcedureFormDoubleButtons);
